import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/lenders`;

export const createLender = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteLender = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateLender = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
